import angular from 'angular';
import constants from 'app/constants';
import {
  reportsDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';

import controller from './bulk-delete-archived-report-instances-confirm-dialog.controller';
import template from './bulk-delete-archived-report-instances-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    reportTypeId,
    archivedReportInstanceIds,
  }) {
    return {
      controller,
      controllerAs: 'bulkDeleteArchivedReportInstancesConfirmDialogVM',
      locals: {
        reportTypeId,
        archivedReportInstanceIds,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.archivedReports.reportType.bulkDeleteArchiveReportInstancesConfirmDialog', [
  alerts,
  reportsDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkDeleteArchivedReportInstancesConfirmDialog', dialogService)
  .name;

console.log('app.components.reports.archivedReports.reportType.bulkDeleteArchivedReportInstancesConfirm created');
